import React, { useEffect, useState } from "react";
import axios from "axios";

import "../../../Layouts/Loader/Loader.css";

import { useAxiosContext } from "../../../context/AxiosContext";
import { useAuth0Context } from "../../../context/Auth0Context";
import { useStatemachineContext } from "../../../context/StatemachineContext";
import { SM_TEMPLATES_API } from "../../../Api/StateMachine";
import Input from "../../../components/FormComponents/Input";
import Button from "../../../components/FormComponents/Button";
import { BASE_URL } from "../../../constant/constant";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const SaveTemplate = ({ callback }) => {
  const [savedImageFile, setSavedImageFile] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const [organisations, setOrganisations] = useState([]);
  const [templateAccessLevel, setTemplateAccessLevel] = useState("zino");
  const [selectedOrg, setSelectedOrg] = useState("");

  const { axiosInstance, handleError, handleSuccess, applicationId } = useAxiosContext();
  const { token } = useAuth0Context();
  const { getStatemachineConfig } = useStatemachineContext();

  const saveTemplate = async (imagePath) => {
    try {
      const config = getStatemachineConfig();

      const allData = {
        image_path: imagePath,
        template_name: templateName,
        template_access_level: templateAccessLevel,
        org_id: templateAccessLevel === "org" ? selectedOrg?.id : "",
        org_name: templateAccessLevel === "org" ? selectedOrg?.name : "",
        ...config
      };
      const { message } = await axiosInstance.post(SM_TEMPLATES_API, allData);

      callback();

      handleSuccess(message);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOrganisations = async () => {
    try {
      const { data } = await axiosInstance.get(`/organisations`);
      setOrganisations(data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    fetchOrganisations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveImage = async () => {
    try {
      const formData = new FormData();

      formData.append("myFile", savedImageFile);

      const { data } = await axios.post(BASE_URL + "/api/v1/uploadasset?type=image", formData, {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
          "Zino-App-Id": applicationId || window.location.pathname.split("/")?.[4] || ""
        }
      });

      await saveTemplate(data.filename);
    } catch (error) {
      handleError(error);
    }
  };

  const handleImageInputChange = (e) => {
    setSavedImageFile(e.target.files[0]);
  };

  const saveButtonHandler = () => {
    const templateNameExist = templateName.trim("");

    if (savedImageFile && templateNameExist) {
      setIsLoading(true);
      saveImage();
    } else if (templateNameExist) {
      setIsLoading(true);
      saveTemplate("");
    } else {
      setShowValidation(true);
    }
  };

  const inputHandleChange = (name) => {
    setShowValidation(false);
    setTemplateName(name);
  };

  return (
    <div className="edit_activity_owner_group builder_form p_2">
      <div className="builder_form ">
        <Input label="Template Name" onChange={(e) => inputHandleChange(e.target.value)} id="template_name" />
        {showValidation && <p className="validation_text">Please enter the template name</p>}
      </div>
      <div>
        <label htmlFor="template_image">Template Image</label>
        <div style={{ marginTop: "4px", color: "GrayText" }}>
          <Input id="template_image" type="file" onChange={handleImageInputChange} />
          <p>Image should be less than 200kb</p>
        </div>
      </div>

      <div>
        <SingleSelectBox
          options={[
            { id: "zino", name: "zino" },
            { id: "org", name: "Organization" }
          ]}
          valueKey="id"
          labelKey="name"
          selectedData={templateAccessLevel}
          onChange={(option) => setTemplateAccessLevel(option.id)}
          label="Template Access Level"
          placeholder="Select access level"
        />
      </div>

      {templateAccessLevel === "org" && (
        <div>
          <SingleSelectBox
            options={organisations}
            valueKey="id"
            labelKey="name"
            selectedData={selectedOrg}
            onChange={(option) => setSelectedOrg(option)}
            label="Select Organization"
            placeholder="Select an organization"
            isSearch={true}
          />
        </div>
      )}

      <Button disabled={isLoading} onClick={saveButtonHandler}>
        {isLoading ? <div className="btn_loader "></div> : "Save"}
      </Button>
    </div>
  );
};

export default SaveTemplate;
